// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"window_wrapper_MubUE","closed":"window_closed_32e0f","top":"window_top_1pdFB","body":"window_body_12gmI"};